import ReactDOM from 'react-dom';

const getFiber = (instance) => {
  if (instance._reactInternals) return instance._reactInternals;
  if (instance._reactInternalFiber) return instance._reactInternalFiber;
  // React 19 exposes the fiber under a hashed key like `__reactFiber$...`.
  const key = Object.getOwnPropertyNames(instance).find((k) =>
    k.startsWith('__reactFiber$'),
  );
  return key ? instance[key] : null;
};

// React 19 removed ReactDOM.findDOMNode, but older libraries still call it to
// locate the host DOM node of a child. Walk the React fiber instead.
export function findDOMNodeCompat(componentOrElement) {
  if (componentOrElement == null) return null;
  if (componentOrElement.nodeType === 1) return componentOrElement;

  const fiber = getFiber(componentOrElement);
  if (!fiber) return null;

  let current = fiber;
  while (current) {
    const node = current.stateNode;
    if (node && node.nodeType === 1) return node;
    current = current.child;
  }
  return null;
}

// Covers libraries that reach findDOMNode through react-dom's live exports
// object - a default import (react-bootstrap) or require() (react-quill,
// react-to-print). A namespace import cannot be fixed this way; see the
// findDOMNodeCompat plugin in vite.config.mjs.
if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = findDOMNodeCompat;
}
